export { default as MenuItem } from './components/menu-item';
export { default as MenuIcon } from './components/menu-icon';



// WEBPACK FOOTER //
// ./src/components/menu-item/index.js